import { css, styled } from 'styled-components'
import { COLORS } from 'consts/colors'
import { DURATIONS, EASING } from 'styles/consts'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const UserInfoBlock = styled.div<{ $isExpanded?: boolean }>`
  padding: 22px;
  border-bottom: 1px solid ${COLORS.border};
  box-sizing: border-box;
  display: flex;
  align-items: center;

  .arrow-icon-wrapper {
    display: none;
  }

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    cursor: pointer;
    padding: 20px 16px;

    .arrow-icon-wrapper {
      display: flex;
    }

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        border: unset;
      `}
  }
`

export const UserDetails = styled.div`
  margin-left: 12px;
  flex-grow: 1;
  overflow: hidden;
`

export const Name = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: ${COLORS.secondaryExtraDark};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  margin-bottom: 6px;
`

export const Email = styled.p`
  color: ${COLORS.secondary};
  font-size: 12px;
  font-weight: 400;
  user-select: none;
  margin-bottom: 6px;
`

export const ViewProfileLink = styled.a`
  position: relative;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.secondarySemiDark};
  text-decoration: none;

  &:after {
    content: '';
    height: 2px;
    width: 0;
    position: absolute;
    left: 0;
    bottom: 0;
    background: linear-gradient(transparent, ${COLORS.secondarySemiDark})
      no-repeat;
    transition: width ${DURATIONS.slow} ${EASING.out};
  }

  &:hover:after {
    width: 100%;
  }

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    display: none;
  }
`
